import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserInfo } from '../contexts/UserInfoContext';
import { UserInfo } from '../types/userInfo';
import { API_BASE_URL } from '../constants/api';

const Login: React.FC = () => {
    const [userId, setUserId] = useState('');
    const [passwd, setPasswd] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const { setUserInfo } = useUserInfo();

    const handleLogin: React.MouseEventHandler<HTMLButtonElement> = async (
        e
    ) => {
        e.preventDefault();
        const postData = {
            userId: userId,
            passwd: passwd,
        };

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000); // 5秒のタイムアウト
        try {
            const response = await fetch(
                `${API_BASE_URL}/students/auth`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams(postData).toString(),
                }
            );
            clearTimeout(timeoutId);
            if (response.ok) {
                const json = await response.json();
                // json.code 'OK' でログイン成功
                if (json.code !== 'ok') {
                    setErrorMessage(json.message);
                    return;
                }
                const user: UserInfo = {
                    id: json.id,
                    kaishaId: json.kaishaId,
                    kyotenId: json.kyotenId,
                    name: json.name,
                    studentItakuKbnId: json.studentItakuKbnId,
                    token: json.token,
                };
                setUserInfo(user);
                // ログイン成功
                navigate('/invoice');
            } else {
                setErrorMessage('ログインに失敗しました');
                return;
            }
        } catch (error) {
            if ((error as Error).name === 'AbortError') {
                setErrorMessage('リクエストがタイムアウトしました');
            } else {
                setErrorMessage('現在サービスのご利用できません!!。');
            }
            return;
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-green-900 to-teal-500">
            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                <h2 className="text-2xl font-bold text-center mb-6">
                    ログイン
                </h2>
                <div className="mb-4">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="userId"
                    >
                        生徒NO:
                    </label>
                    <input
                        type="text"
                        id="userId"
                        value={userId}
                        onChange={(e) => setUserId(e.target.value)}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                </div>
                <div className="mb-6">
                    <label
                        className="block text-gray-700 text-sm font-bold mb-2"
                        htmlFor="password"
                    >
                        パスワード:
                    </label>
                    <input
                        type="password"
                        id="password"
                        value={passwd}
                        onChange={(e) => setPasswd(e.target.value)}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    />
                </div>
                <div>
                    {errorMessage && (
                        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded">
                            {errorMessage}
                        </div>
                    )}
                </div>
                <div className="flex items-center justify-center">
                    <button
                        onClick={handleLogin}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full shadow-md transition duration-300 ease-in-out transform hover:scale-105"
                    >
                        ログイン
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;
